require('jquery')('.fancybox').fancybox();
